
export class SalvusHealthAuthentication {
    constructor(public apb_number: string, public api_key: string) {

    }
}
